/*

  Gameview.ts

  Game view component

  Copyright (C) 2025 Miðeind ehf.
  Author: Vilhjalmur Thorsteinsson

  The Creative Commons Attribution-NonCommercial 4.0
  International Public License (CC-BY-NC 4.0) applies to this software.
  For further information, see https://github.com/mideind/Netskrafl

*/

import { Component, m } from "./mithril";
import { IView } from "./types";
import { Info, LeftLogo } from "./components";
import { BlankDialog } from "./blankdialog";
import { Bag } from "./bag";
import { BoardArea } from "./board";
import { RightColumn } from "./rightcolumn";
import { Beginner } from "./beginner";

interface IAttributes {
  view: IView;
}

export const GameView: Component<IAttributes> = {
  // A view of a game, in-progress or finished

  view: (vnode) => {
    const { view } = vnode.attrs;
    const { model } = view;
    const { game, state } = model;
    if (!game) {
      // No associated game
      return m("div", [m(".game-container"), m(LeftLogo)]);
    }
    const { bag, newbag } = game;
    return m(
      // Allow tiles to be dropped on the background
      // by marking the div with the drop-target class.
      // Such a drop sends the tile back into the rack.
      "div.drop-target",
      {
        id: "board-background",
      },
      [
        // The main game area
        m(".game-container",
          [
            m(RightColumn, { view }),
            m(BoardArea, { view, game }),
            // The bag is visible in fullscreen
            state?.uiFullscreen ? m(Bag, { bag: bag, newbag: newbag }) : "",
            game.askingForBlank ? m(BlankDialog, { game }) : ""
          ]
        ),
        // The left margin stuff: back button, square color help, info/help button
        // These elements appear after the game container, since we want
        // them to be above it in the z-order
        m(LeftLogo),
        state?.beginner ? m(Beginner, { view, showClose: true }) : "",
        m(Info),
      ]
    )
  }
};
